import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ConfirmTransfer from "./ConfirmTransfer";
import TransferReceipt from "./TransferReceipt";
import TransferPayments from "./context";
import TransfersAndPayments from "./TransfersAndPayments";
const TransferAndPaymentsPage = () => {
    return (_jsxs(TransferPayments, { transferType: "", children: [_jsx(TransferPayments.Create, { children: _jsx(TransfersAndPayments, {}) }), _jsx(TransferPayments.Confirm, { children: _jsx(ConfirmTransfer, {}) }), _jsx(TransferPayments.Receipt, { children: _jsx(TransferReceipt, {}) })] }));
};
export default TransferAndPaymentsPage;
